import { render, staticRenderFns } from "./comVideo.vue?vue&type=template&id=480fd1c4&"
import script from "./comVideo.vue?vue&type=script&lang=js&"
export * from "./comVideo.vue?vue&type=script&lang=js&"
import style0 from "./comVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports